import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'
import { PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import type { TPelaksanaanAppealableStep } from 'types/kinerja-pelaksanaan'

type CardNotificationPelaksanaanAppealGuruProps = CardNotificationBaseProps & {
  isApproved: boolean
  step: TPelaksanaanAppealableStep
}

export function CardNotificationPelaksanaanAppealGuru({
  isApproved,
  step,
  ...cardProps
}: CardNotificationPelaksanaanAppealGuruProps) {
  if (!isApproved) {
    return <CardNotificationBase {...cardProps} />
  }

  return (
    <CardNotificationBase {...cardProps}>
      <div className="mt-6">
        <Link
          href={
            PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[step]?.path ??
            PENGELOLAAN_KINERJA_GURU_PATH
          }
          passHref
        >
          <Button as="a" className="!inline-flex" type={undefined}>
            Cek dokumen
          </Button>
        </Link>
      </div>
    </CardNotificationBase>
  )
}
